
import { defineComponent } from 'vue';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon, IonSpinner } from '@ionic/vue';
import { refreshOutline } from 'ionicons/icons';
import { leadApi, formatDateTime } from '../../salesLeads';

/** Scheduled meetings on leads I own or am invited to: overdue feedback first, then today, then later. */
export default defineComponent({
  name: 'SalesLeadMeetings',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonMenuButton, IonButton, IonIcon, IonSpinner },
  data() {
    return { meetings: [] as any[], loading: true, refreshOutline };
  },
  computed: {
    groups(): { title: string; cls: string; items: any[] }[] {
      const today = new Date().toDateString();
      const when = (m: any) => new Date(String(m.scheduled_at).replace(' ', 'T'));
      const now = Date.now();
      return [
        { title: 'Feedback overdue', cls: 'late', items: this.meetings.filter(m => m.feedback_overdue) },
        { title: 'Earlier today / waiting for feedback', cls: 'due', items: this.meetings.filter(m => !m.feedback_overdue && when(m).getTime() < now) },
        { title: 'Today', cls: '', items: this.meetings.filter(m => when(m).getTime() >= now && when(m).toDateString() === today) },
        { title: 'Upcoming', cls: '', items: this.meetings.filter(m => when(m).getTime() >= now && when(m).toDateString() !== today) },
      ];
    },
  },
  created() {
    this.load();
  },
  methods: {
    time: formatDateTime,
    load() {
      this.loading = true;
      leadApi('myMeetings', {}, true).then(r => {
        this.meetings = r.data.meetings;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
});
